import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

import ConfirmDelete from '@/views/Language/dialogs/confirmDelete/confirmDelete.vue'

import store from '@/store'

export default class TagModel extends JsonApiObject {
    static async post(data: any) {
        let query = {
            body: { data: data },
        }

        let res = await Vue.prototype.$vbit.post('language', `tags`, query)

        if (res.data) {
            let tag = new TagModel(res.data, res.included)
            store.commit('tag', tag)
            return tag
        } else {
            return res
        }
    }

    static async get(tagId: string) {
        let query = {}

        let res = await Vue.prototype.$vbit.get('language', `tags/${tagId}`, query)

        return res.data ? new TagModel(res.data, res.included) : res
    }

    static async getAllTags(token: string | null = null) {
        let query = {
            ...(token && {
                token,
            }),
        }

        let res = await Vue.prototype.$vbit.get('language', `tags`, query)

        let tags = res.data.map((tag) => new TagModel(tag, res.included))

        return tags
    }

    public constructor(data: any, included?) {
        super(data, included)
    }

    name
    deleted
    createdAt
    updatedAt

    get statistics() {
        return this._relationships['statistics'] ? this._relationships['statistics'] : null
    }

    async patchName(name: string) {
        let data = {
            id: this._id,
            type: this._type,
            attributes: {
                name,
            },
        }

        return await this.patch(data)
    }

    async delete() {
        let res = await JsonApiObject.openDialog(ConfirmDelete, {
            name: this.name,
            deleted: this.deleted,
            type: 'tag',
            needConfirm: false,
        })
        if (res) {
            let data = {
                id: this._id,
                type: this._type,
                attributes: {
                    deleted: !this.deleted,
                },
            }

            return await this.patch(data)
        }
    }

    async patch(data: any) {
        let query = {
            body: { data: data },
            updatedAt: this['updatedAt'],
        }

        let res = await Vue.prototype.$vbit.patch('language', `tags/${this._id}`, query)

        if (res.data) {
            let tag = new TagModel(res.data, res.included)
            store.commit('tag', tag)
            return tag
        } else {
            return res
        }
    }
}
